import React, { useEffect } from "react";

const MoreMenu = ({ items, activeTab, onItemClick, isOpen, onClose }) => {
  // Close on escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  // Prevent body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      {/* Backdrop */}
      <div
        className={`bottom-nav-overlay ${isOpen ? "bottom-nav-overlay--open" : ""}`}
        onClick={onClose}
      />

      {/* Sheet */}
      <div className={`bottom-nav-more ${isOpen ? "bottom-nav-more--open" : ""}`}>
        <div className="bottom-nav-more__handle">
          <div className="bottom-nav-more__handle-bar" />
        </div>

        <div className="bottom-nav-more__grid">
          {items.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.path || activeTab.startsWith(item.path + "/");
            return (
              <button
                key={item.id}
                className={`bottom-nav-more__item ${isActive ? "bottom-nav-more__item--active" : ""}`}
                onClick={() => {
                  onItemClick(item.path);
                  onClose();
                }}
              >
                <span className="bottom-nav-more__item-icon">
                  <Icon />
                </span>
                <span className="bottom-nav-more__item-label">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default MoreMenu;
